import { XRFieldTypeAnnotatedParamJson } from "../ItemConfiguration";
import { IFieldHandler } from "./IFieldHandler";
export { TextlineFieldHandler };

class TextlineFieldHandler implements IFieldHandler {
    private data: string;
    private config: XRFieldTypeAnnotatedParamJson;
    private fieldType: string;

    constructor(fieldType: string, configIn: XRFieldTypeAnnotatedParamJson) {
        this.fieldType = fieldType;
        this.config = configIn;
        // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
        this.data = undefined;
    }

    getFieldType(): string {
        return this.fieldType;
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    initData(serializedFieldData: string | undefined) {
        if (serializedFieldData !== undefined) {
            this.data = serializedFieldData;
        } else if (this.config.initialContent) {
            this.data = this.config.initialContent;
        }
    }
    getData(): string | undefined {
        return this.data;
    }
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    setData(value: string, doValidation?: boolean) {
        this.data = value;
    }
    getText(): string {
        return this.data;
    }
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    setText(str: string) {
        // make sure there are no newlines if this is a one row field.
        // TODO: MATRIX-7555: lint errors should be fixed for next line
        // eslint-disable-next-line
        if (this.config.rows && this.config.rows == 1) {
            this.data = str.replace("\n", "");
        } else {
            this.data = str;
        }
    }
}
